import { PageView } from '../widgets';
import type { ScreenProps } from './types';

/**
 * Home is a page like any other, composed from config. Its widgets, their order
 * and their settings are the admin's to change; the default reproduces the app
 * as it shipped before the admin existed.
 */
export function Home(props: ScreenProps) {
  return <PageView pageId="home" ctx={{ ...props, cmsUrl: props.cmsUrl }} />;
}

/** Any page the admin added. Falls back to Home if it has since been removed. */
export function CustomPage(props: ScreenProps) {
  return <PageView pageId={props.state.pageId} ctx={{ ...props, cmsUrl: props.cmsUrl }} />;
}
